import { makeStyles } from '@material-ui/core';
import { ISpcTheme } from '../../../../common/theme/ISpcTheme';

export type StickyFooterClasses =
  | 'footerWrapper'
  | 'financeDisplay'
  | 'footerLoader'
  | 'hideOnMobile'
  | 'footerWrapperLoader'
  | 'summaryLabel'
  | 'footerContent';

const stickyFooterContainerStyles = makeStyles<ISpcTheme, StickyFooterClasses>(
  theme => ({
    footerWrapperLoader: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: theme.palette.background.alternate,
      minHeight: '110px',

      [theme.breakpoints.down('md')]: {
        minHeight: '80px',
        backgroundColor: theme.palette.common.white,
        boxShadow: '0 -3px 6px rgba(0, 0, 0, .2)',
      },
    },
    footerWrapper: {
      display: 'flex',
      position: 'relative',
      justifyContent: 'space-between',
      backgroundColor: theme.palette.background.alternate,
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.text.secondary,
      padding: `8px 32px`,
      minHeight: '110px',
      transform: 'translateY(0)',
      transition: theme.transitions.create(['transform']),

      [theme.breakpoints.down(1420)]: {
        padding: `8px 14px`,
        zIndex: -999,
      },

      [theme.breakpoints.down('md')]: {
        justifyContent: 'center',
        backgroundColor: theme.palette.common.white,
        boxShadow: '0 -3px 6px rgba(0, 0, 0, .2)',
      },
      [theme.breakpoints.down('xs')]: {
        minHeight: '80px',
        padding: '20px 0',
      },
    },
    financeDisplay: {
      [theme.breakpoints.down('md')]: {
        minHeight: 130,
      },
    },
    footerLoader: {
      minHeight: 80,
    },
    hideOnMobile: {
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
    summaryLabel: {
      display: 'flex',
      maxHeight: '35px',
      position: 'absolute',
      top: 0,
      right: 0,
    },
    footerContent: {},
  }),
  { name: 'Customise_StickyFooterContainer' },
);

export default stickyFooterContainerStyles;
